import { Stack } from "@mui/material";
import type { ActivityLogDetail } from "../../../../../api/types/activityLogTypes";
import ActivityRowGridDetailLine from "./ActivityRowGridDetailLine";

interface Props {
  details: ActivityLogDetail[];
}

const ActivityRowGridDetail = ({ details }: Props) => {
  return (
    <Stack spacing={1} sx={{ px: 7, py: 1.5 }}>
      {details.map((detail, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <ActivityRowGridDetailLine key={index} detail={detail} />
      ))}
    </Stack>
  );
};

export default ActivityRowGridDetail;
